import React from 'react';
import SelectField from 'material-ui/SelectField';
import Checkbox from 'material-ui/Checkbox';
import DatePicker from 'material-ui/DatePicker';
import DatePickerDialog from 'material-ui/DatePicker/DatePickerDialog';
import moment from 'moment';
import TextField from 'material-ui/TextField';
import { Iterable } from 'immutable';
import DateIcon from 'material-ui/svg-icons/action/date-range';
import { reduxForm } from 'redux-form';
import { reduxForm as reduxImmutableForm } from 'redux-form/immutable';

import validate from 'validate.js';

export const asyncValidate = validate => (values /*, dispatch */) => {
    return new Promise((resolve, reject) => {
        const errors = validate(values);
        if (!_.isEmpty(errors)) {
            reject(errors);
        } else {
            resolve();
        }
    });
};

export const validationImmutableReduxForm = (name, validationFunction) => {
    return reduxImmutableForm({
        form: name,
        enableReinitialize: true,
        validate: validationFunction,
    });
};

export const validationReduxForm = (name, validationFunction) => {
    return reduxForm({
        form: name,
        enableReinitialize: true,
        validate: validationFunction,
    });
};

export const validateConstraints = (values, constraints) => validate(values, constraints);

const formatDate = date => {
    return moment(date).format('DD.MM.YYYY');
};

export class DatePickerWrapper extends React.Component {
    onChange(evt, date) {
        if (this.props.onChange) {
            this.props.onChange(date);
            this.props.onChangeWrapper(date);
        }
    }

    render() {
        let { value, hintText, floatingLabelText, errorText, style } = this.props;
        if (value !== undefined && value !== '') {
            value = moment(value).toDate();
        } else {
            value = null;
        }
        return (
            <DatePicker
                minDate={new Date(1900, 1, 1)}
                textFieldStyle={style}
                style={style}
                errorText={errorText}
                value={value}
                floatingLabelStyle={{ zIndex: 0 }}
                floatingLabelText={floatingLabelText}
                hintText={hintText}
                DateTimeFormat={Intl.DateTimeFormat}
                onChange={this.onChange.bind(this)}
                locale="de"
                formatDate={formatDate}
            />
        );
    }
}

export class TextFieldDatepickerWrapper extends React.Component {
    constructor(props) {
        super(props);
        let { value } = props;
        let date = this.parseDate(value);

        this.state = {
            focused: false,
            date: date,
            text: date ? this.formatDate(date) : '',
        };
    }

    formatDate = (date, format = 'DD.MM.YYYY', locale = 'de') => {
        moment.locale(locale);
        return moment(date).format(format);
    };

    parseDate = (
        string,
        formats = ['DD MM YYYY', moment.ISO_8601],
        locale = 'de',
        strictParsing = false
    ) => {
        return this.isValidDate(string, formats, locale, strictParsing)
            ? moment(string, formats, locale, strictParsing).toISOString()
            : null;
    };

    isValidDate = (
        date,
        formats = ['DD MM YYYY', moment.ISO_8601],
        locale = 'de',
        strictParsing = false
    ) => {
        return date && moment(date, formats, locale, strictParsing).isValid();
    };

    onChangeText = (evt, text) => {
        this.setState({ text: text });
        this.changeDate(text);
    };

    changeDate = date => {
        var date = this.parseDate(date);
        this.setState({ date: date });
        this.props.onChange && this.props.onChange(date);
    };

    onFocus = () => {
        this.setState({ focused: true });
        if (this.props.onFocus) {
            this.props.onFocus();
        }
    };

    onBlur = () => {
        this.setState({ focused: false });
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    };

    render = () => {
        let { date, text } = this.state;

        return (
            <div style={this.props.style}>
                <DatePickerDialog
                    DateTimeFormat={Intl.DateTimeFormat}
                    autoOk={false}
                    cancelLabel="ABBRECHEN"
                    container="dialog"
                    disableYearSelection={false}
                    firstDayOfWeek={1}
                    initialDate={date ? moment(date).toDate() : new Date()}
                    locale="de"
                    maxDate={new Date(2100, 1, 1)}
                    minDate={new Date(1900, 1, 1)}
                    mode="portrait"
                    okLabel="OK"
                    onAccept={date => {
                        this.onChangeText(null, this.formatDate(date));
                    }}
                    onShow={() => {}}
                    onDismiss={() => {}}
                    ref="dialogWindow"
                    shouldDisableDate={() => {}}
                />

                <TextField
                    hintText={this.props.label}
                    floatingLabelText={this.props.label}
                    errorText={
                        this.props.touched &&
                        (this.props.error ||
                            asyncErrors(this.props.validationErrors, this.props.name))
                    }
                    {...this.props}
                    style={{ width: '90%' }}
                    value={text}
                    onChange={this.onChangeText}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                />
                <DateIcon
                    style={{ width: '10%' }}
                    onClick={() => {
                        this.refs.dialogWindow.show();
                    }}
                />
            </div>
        );
    };
}

export class SelectFieldWrapper extends React.Component {
    onChange(evt, index, value) {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }
    render() {
        let { value } = this.props;
        value = String(value);
        return (
            <SelectField {...this.props} value={value} onChange={this.onChange.bind(this)}>
                {this.props.children}
            </SelectField>
        );
    }
}

export class CheckboxWrapper extends React.Component {
    onCheck(evt, value) {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }
    render() {
        let { value, label } = this.props;
        value = this.stringToBoolean(value);
        return <Checkbox label={label} checked={value} onCheck={this.onCheck.bind(this)} />;
    }
    stringToBoolean(string) {
        if (typeof string === 'boolean') {
            return string;
        }
        if (string === undefined) {
            string = false;
        }
        switch (string.toLowerCase().trim()) {
            case 'true':
            case 'yes':
            case '1':
                return true;
            case 'false':
            case 'no':
            case '0':
            case null:
                return false;
            default:
                return Boolean(string);
        }
    }
}

const isNullUndefinedOrEmptyEnumerable = obj => {
    return (
        obj == null ||
        obj == undefined ||
        (!!obj && obj.constructor == Array && obj.length == 0) || // only true with objects created within the same frame, see @duck-typing
        (Iterable.isIterable(obj) && obj.count() == 0)
    );

    // typeof array && array.count == 0
    // typeof map && map.count == 0
};

const isAnyNullUndefinedOrEmptyEnumerable = (...objects) => {
    return objects.filter(obj => isNullUndefinedOrEmptyEnumerable(obj)).length > 0;
};

const asyncErrors = (errors, fieldName) => {
    if (isAnyNullUndefinedOrEmptyEnumerable(errors, fieldName)) {
        return null;
    }

    if (errors.has(fieldName)) {
        return errors.get(fieldName);
    } else {
        return null;
    }
};

export const renderTextField = props => {
    return (
        <TextField
            hintText={props.label}
            floatingLabelText={props.label}
            style={{ width: '100%' }}
            errorText={getError(props)}
            {...props}
        />
    );
};

export const renderCheckbox = props => (
    <Checkbox label={props.label} checked={props.value ? true : false} onCheck={props.onChange} />
);

const getError = props => {
    return (
        (props.touched && (props.error || asyncErrors(props.validationErrors, props.name))) ||
        asyncErrors(props.validationErrors, props.name)
    );
};

export const renderDatePicker = props => (
    <DatePickerWrapper
        floatingLabelText={props.label}
        errorText={getError(props)}
        {...props}
        onChangeWrapper={() => {}}
    />
);

export const renderSelectField = props => (
    <SelectField
        floatingLabelStyle={{ zIndex: 0 }}
        floatingLabelText={props.label}
        {...props}
        onChange={(event, index, value) => props.onChange(value)}
        errorText={getError(props)}
    />
);

export const renderTextFieldDatepickerWrapper = props => (
    <TextFieldDatepickerWrapper
        floatingLabelStyle={{ zIndex: 0 }}
        floatingLabelText={props.label}
        errorText={getError(props)}
        {...props}
        onChange={props.onChange}
    />
);

export const renderMatrixWrapper = props => <MatrixWrapper {...props} />;
